<template>
    <div class="w-full">
        <div class="flex items-center justify-between">
            <div class="flex items-center gap-x-[12px] mb-[16px]">
                <FileArchive :size="18" strokeWidth="1.3"/> <span class="font-light">Documents</span>
            </div>

            <DialogRoot>
                <DialogTrigger>
                    <button class="text-white rounded-lg h-[36px] px-4 bg-[#3c41e9] flex items-center justify-center">
                        Ajouter un document
                    </button>
                </DialogTrigger>
                <DialogPortal>
                    <DialogOverlay className="fixed z-[1000] inset-0 bg-[#00000044] data-[state=open]:animate-overlayShow"/>
                    <DialogContent className="fixed text-black p-0 overflow-hidden w-[48%] z-[1001] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none data-[state=open]:animate-contentShow">
                        <div class="bg-[#eeeeee] px-5 py-8">
                            <DialogTitle class="font-light">Ajouter un document</DialogTitle>
                        </div>
                        <div class="p-5">

                            <div class="flex flex-col gap-1 items-start w-full">
                                <label htmlFor="formation" class="font-extralight">Sélectionner le type de document<span class="text-[#f00]">*</span></label>
                                <div class="w-full">
                                    <select v-model="formdata.type" name="formation" id="formation" class="w-1/2 min-h-[45px] border rounded-lg">
                                        <option>Selectionner le type</option>
                                        <option v-for="(v,idx) in type_papers" :key="idx" :value="v.id">
                                            {{ v.title }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="flex items-start gap-x-3 w-full mt-4">
                                <div class="flex flex-col gap-1 items-start grow">
                                    <label htmlFor="numero" class="font-extralight"> Numéro<span class="text-[#f00]">*</span></label>
                                    <input type="text" v-model="formdata.numero" name="numero" placeholder="CI0000000" autoComplete="off" class="h-[45px] w-full border rounded-lg p-3"/>
                                </div>
                            </div>

                            <div class="flex items-start gap-x-3 w-full mt-4">
                                <div class="flex flex-col gap-1 items-start grow">
                                    <label htmlFor="debut" class="font-extralight">Date d'émission <span class="text-[#f00]">*</span></label>
                                    <div class="w-full">
                                        <input type="date" v-model="formdata.start" name="debut" placeholder="" autoComplete="off" class="h-[45px] border rounded-lg p-3 cursor-pointer w-full"/>
                                    </div>
                                </div>
                                <div class="flex flex-col gap-1 items-start grow">
                                    <label htmlFor="fin" class="font-extralight">Date d'expiration <span class="text-[#f00]">*</span></label>
                                    <div class="w-full">
                                        <input type="date" name="fin" v-model="formdata.end" placeholder="" autoComplete="off" class="h-[45px] border rounded-lg p-3 cursor-pointer w-full"/>
                                    </div>
                                </div>
                            </div>

                            <div class="flex items-start gap-x-3 w-full mt-4">
                                <div class="flex flex-col gap-1 items-start grow">
                                    <span class="font-extralight">Document</span>
                                    <div class="flex items-center justify-between w-full">
                                        <label htmlFor="fichier" class="font-extralight h-[45px] w-[49%] hover:bg-[#f1f1f1] transition-all cursor-pointer flex items-center justify-center rounded-lg border border-dashed">
                                            Charger un fichier
                                        </label>
                                        <div class="flex items-center justify-center h-full font-light w-[49%]">
                                            <span v-if="!file">Aucun fichier charger</span>
                                            <span v-else>Un fichier charger</span>
                                        </div>
                                    </div>
                                    <div class="w-full">
                                        <input type="file" v-on:change="selectFiles" accept="image/*,.pdf" name="fichier" id="fichier" placeholder="" autoComplete="off" class="h-[45px] hidden"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="h-[1px] w-full bg-[#ccc]" />
                        <div class="flex items-center justify-end px-5 py-5 gap-x-5">
                            <DialogClose as-child>
                                <button type="button" class="border py-3 px-8 rounded-md">
                                    Fermer
                                </button>
                            </DialogClose>
                            <button v-on:click="addPaper" :disabled="asSend" type="button" class="py-3 px-8 rounded-md text-white bg-[#5357ec]">
                                <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                                <span v-else>Enregistrer</span>
                            </button>
                        </div>
                    </DialogContent>
                </DialogPortal>
            </DialogRoot>
        </div>

        <div v-if="papers.length != 0" class="mt-6 w-full grid grid-cols-4 gap-4">
            <div v-for="(value,idx) in papers" :key="idx" class="border w-full rounded-lg p-4 flex flex-col gap-y-3">
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-x-2">
                        <FileArchive :size="20" strokeWidth="1.3"/>
                        <span class="font-light text-sm">
                            {{ type_papers.filter((item)=> item.id == value.type_doc_id)[0].title  }}
                        </span>
                    </div>
                    <a :href="'https://backend-ehr.iugb-ci.com/public/image/'+ value.file" target="_blank" class="text-sm text-[#3c41e9] underline font-light">
                        Voir le document
                    </a>
                </div>
            </div>
        </div>
        <div v-else class="h-[250px] w-full flex items-center justify-center">
            <p class="font-extralight">
                Aucun document disponible
            </p>
        </div>
    </div>
</template>
<script>
    import API from '@/service/API';
    import {FileArchive,Loader2} from "lucide-vue-next";
    import Swal from 'sweetalert2';
    import {
        DialogClose,
        DialogContent,
        DialogOverlay,
        DialogPortal,
        DialogRoot,
        DialogTitle,
        DialogTrigger,
    } from 'radix-vue';
    export default {
        name: "DocumentColab",
        components:{
            Loader2,
            FileArchive,
            DialogClose,
            DialogContent,
            DialogOverlay,
            DialogPortal,
            DialogRoot,
            DialogTitle,
            DialogTrigger,
        },
        data(){
            return {
                papers:[],
                type_papers:[],
                asSend: false,
                formdata:{
                    type: "",
                    numero: "",
                    start: "",
                    end: "",
                    file: null,
                },
            }
        },
        mounted(){
            this.getAllPapers();
            this.getAllPapersType();
        },
        methods:{
            clearForm(){
                this.formdata = {
                    type: "",
                    numero: "",
                    start: "",
                    end: "",
                    file: null,
                }
            },
            getAllPapersType(){
                API.get("type-docs")
                .then((response)=>{
                    if(!response.data.status) throw Error(response.data.message);
                    this.type_papers = response.data.data;
                })
                .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            },
            getAllPapers(){
                API.get("papers")
                .then((response)=>{
                    if(!response.data.status) throw Error(response.data.message);
                    this.papers = response.data.data;
                })
                .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            },
            selectFiles(e){
                if (!e.target.files[0]) return;
                this.formdata.file = e.target.files[0];
            },
            addPaper(){
                this.asSend = true;
                const formData = new FormData();
                const userId = localStorage.getItem("userId")
                formData.append("user_id", userId);
                formData.append("type_doc_id", this.formdata.type);
                formData.append("file", this.formdata.file);
                formData.append("numero", this.formdata.numero);
                formData.append("date_emission", this.formdata.start);
                formData.append("date_expiration", this.formdata.end);
                API.post("papers",formData)
                .then((response)=>{
                    if(!response.data.status) throw Error(response.data.message);
                    this.getAllPapers();
                    this.clearForm();
                    Swal.fire('Succès',"Document enregistré",'succes');
                })
                .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
                .finally(()=>{this.asSend = false;})
            }
        }
    }
</script>